// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Minoxidil / Finasteride   (Men & Women) 09.17.26" (b6b8d045-12de-45fb-90c5-dbefb579964d). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiMinoxidilFinasterideMenWomenQuestions = [
  {
    field: 'mdiMinoxidilFinasterideMenWomen_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_wereSorryDueEitherBeing',
    label:
      "We're sorry, due to either being pregnant, trying to conceive, or current breastfeeding, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '5734cad9-2364-45ce-9da5-93ff8773db78',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_tryingConceivePlanConceivingNear',
    label:
      'Are you currently trying to conceive or plan on conceiving in the near future?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '23edba35-0702-4d11-ae0e-5c4daa391d4e' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_wereSorryBasedPreviousResponse',
    label:
      "We're sorry, based on your previous response, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '77a2f996-a5eb-4829-998a-bff8e00ab383',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field:
      'mdiMinoxidilFinasterideMenWomen_requiredAcknowledgmentUnderstandFormulationContains',
    label:
      'Required Acknowledgment: I understand this formulation contains Finasteride, which may pose risks during pregnancy and must not be used if pregnant or attempting conception.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'i_agree', value: 'I agree' }]
    },
    extras: { mdiQuestionId: '154dc84b-2c94-4221-9523-e2ce1ade8a1b' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_primaryConcern',
    label: 'What is your primary concern?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hair_thinning', value: 'Hair thinning' },
        { key: 'receding_hairline', value: 'Receding hairline' },
        { key: 'bald_spots', value: 'Bald spots' },
        { key: 'excess_shedding', value: 'Excess shedding' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: 'e20e2e52-70eb-4dac-bdcc-bfdb9436f644' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_didFirstNoticeHairLoss',
    label: 'When did you first notice hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_6_months_ago', value: 'Less than 6 months ago' },
        { key: 'o_6_12_months_ago', value: '6-12 months ago' },
        { key: 'o_1_3_years_ago', value: '1-3 years ago' },
        { key: 'longer_than_3_years_ago', value: 'Longer than 3 years ago' }
      ]
    },
    extras: { mdiQuestionId: '05a30ee4-f387-4713-a442-e6a285b64483' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_whereHairLossOccurring',
    label: 'Where is the hair loss occurring?',
    type: 'select',
    educationalSlide: '(Select all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'crown', value: 'Crown' },
        { key: 'temples', value: 'Temples' },
        { key: 'entire_scalp', value: 'Entire scalp' },
        { key: 'patchy_areas', value: 'Patchy areas' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '30393870-d9af-4d41-ba41-8bc8ad4b7341' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_hairLoss',
    label: 'Has your hair loss:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'stayed_the_same', value: 'Stayed the same' },
        { key: 'gradually_worsened', value: 'Gradually worsened' },
        { key: 'rapidly_worsened', value: 'Rapidly worsened' }
      ]
    },
    extras: { mdiQuestionId: 'f41aaf11-9699-494e-8463-6ddca42d741b' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_familyHistoryHairLoss',
    label: 'Do you have a family history of hair loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' },
        { key: 'unsure', value: 'Unsure' }
      ]
    },
    extras: { mdiQuestionId: '2066e0ab-4c61-4184-b5b3-cbae40c5cbb1' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_conditions',
    label: 'Do you have any of the following conditions?',
    type: 'select',
    educationalSlide: '(Select all that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'liver_disease', value: 'Liver disease' },
        {
          key: 'hormonal_disorders_e_g_pcos_thyroid_issu',
          value: 'Hormonal disorders (e.g., PCOS, thyroid issues)'
        },
        {
          key: 'scalp_conditions_eczema_psoriasis_infect',
          value: 'Scalp conditions (eczema, psoriasis, infections)'
        },
        {
          key: 'anemia_or_nutrient_deficiency',
          value: 'Anemia or nutrient deficiency'
        },
        {
          key: 'skin_conditions_eczema_psoriasis_dermati',
          value: 'Skin conditions (eczema, psoriasis, dermatitis)'
        },
        { key: 'prostate_conditions', value: 'Prostate conditions' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '9528046b-4929-4c1f-acf6-38bb921327fc' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_everDiagnosed',
    label: 'Have you ever been diagnosed with any of the following?',
    type: 'select',
    educationalSlide: '(select any that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'androgenetic_alopecia', value: 'Androgenetic alopecia' },
        { key: 'alopecia_areata', value: 'Alopecia areata' },
        { key: 'telogen_effluvium', value: 'Telogen effluvium' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'bae4d00b-ea8a-414c-af0d-420f538667ff' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding',
    label:
      'Can you provide your doctor with more insight regarding your diagnosis?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding',
      rows: 4
    },
    extras: { mdiQuestionId: '9b743eaa-0dc9-4952-88cd-0815fd6789de' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_usingHairLossTreatmentsIncludes',
    label:
      'Are you currently using any hair loss treatments? This includes any oral or topical products.',
    type: 'select',
    educationalSlide:
      'If yes, please list what treatments you are currently using.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '2aaed85a-fe37-488c-ac89-346b7a3e936a' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_youuseProducts',
    label: 'Have youuse any of the following products?',
    type: 'select',
    educationalSlide:
      'Select those that apply, then further explain your experience.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'minoxidil',
          value: 'Minoxidil',
          answer: {
            type: 'text',
            name: 'minoxidil_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'retinoids_e_g_tretinoin',
          value: 'Retinoids (e.g., tretinoin)',
          answer: {
            type: 'text',
            name: 'retinoids_e_g_tretinoin_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'alcohol_based_topicals',
          value: 'Alcohol-based topicals',
          answer: {
            type: 'text',
            name: 'alcohol_based_topicals_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'finasteride', value: 'Finasteride' },
        { key: 'dutasteride', value: 'Dutasteride' },
        { key: 'ketoconazole_shampoo', value: 'Ketoconazole shampoo' },
        { key: 'microneedling', value: 'Microneedling' },
        { key: 'prp', value: 'PRP' },
        {
          key: 'i_have_not_tried_any_of_the_above_produc',
          value: 'I have NOT tried any of the above products'
        }
      ]
    },
    extras: { mdiQuestionId: 'e9c854f1-9004-4afa-a08d-3866004652d4' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried',
    label: 'How was your experience with the products you tried?',
    type: 'info',
    subLabel: 'Did you have any side effects?  Did you notice improvement?',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideMenWomen_experienceProductsTried',
      rows: 4
    },
    extras: { mdiQuestionId: 'f4b53e08-d827-4613-bf90-d6d99d78999f' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_scalpIrritationOpenWoundsInfection',
    label: 'Do you have scalp irritation, open wounds, or infection?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '4e0d88dd-f7ec-4a55-bacc-2047ee994334' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_redness',
    label: 'Do you currently have:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'redness', value: 'Redness' },
        { key: 'flaking', value: 'Flaking' },
        { key: 'itching', value: 'Itching' },
        { key: 'burning', value: 'Burning' },
        { key: 'none', value: 'None' }
      ]
    },
    extras: { mdiQuestionId: '9d7cc19b-eb43-4aae-aa0a-5b756c095bcb' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_history',
    label: 'Do you have a history of',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'eczema', value: 'Eczema' },
        { key: 'seborrheic_dermatitis', value: 'Seborrheic dermatitis' },
        { key: 'psoriasis', value: 'Psoriasis' },
        { key: 'contact_dermatitis', value: 'Contact dermatitis' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '12df3851-8d3b-46cf-9683-5acd874084e1' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_usingScalp',
    label: 'Are you currently using any of the following on your scalp?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'exfoliating_acids_salicylic_glycolic_lac',
          value: 'Exfoliating acids (salicylic, glycolic, lactic)'
        },
        { key: 'medicated_shampoos', value: 'Medicated shampoos' },
        { key: 'topical_steroids', value: 'Topical steroids' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'da74750a-9c18-4d9b-ad8c-d1fde374b4e3' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_historyLowBloodPressureDizziness',
    label: 'Do you have a history of low blood pressure or dizziness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'b2671434-9528-4109-a427-1ead56f54703' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_experiencedDecreasedLibidoLately',
    label: 'Have you experienced decreased libido lately?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '98820d4b-a96a-4b6d-8997-9b4037c4e38c' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_experienced',
    label: 'Have you experienced any of the following?',
    type: 'select',
    educationalSlide: '(select those that apply)',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'decreased_libido', value: 'Decreased libido' },
        { key: 'erectile_dysfunction', value: 'Erectile dysfunction' },
        { key: 'ejaculatory_issues', value: 'Ejaculatory issues' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: '4644d728-8009-4b29-829e-e0d2abfad5ba' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_fertilityConcerns',
    label: 'Have you had any fertility concerns?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'c48bf966-29aa-42b8-ab3c-8ae593d74235' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding2',
    label:
      'Can you please provide your doctor with more insight regarding your fertility concerns?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRegarding2',
      rows: 4
    },
    extras: { mdiQuestionId: 'a8c58cb5-fc95-40ca-9d6e-e928ddb6d9ba' }
  },
  {
    field:
      'mdiMinoxidilFinasterideMenWomen_historyDepressionAnxietyMoodDisorders',
    label: 'Do you have a history of depression, anxiety, or mood disorders?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '8e25fd98-269e-45fe-a747-fc0e85f8a308' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_provideDoctorFurtherInsightHistory',
    label:
      'Can you please provide your doctor with further insight to your history ofdepression, anxiety, or mood disorders?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideMenWomen_provideDoctorFurtherInsightHistory',
      rows: 4
    },
    extras: { mdiQuestionId: '829cf096-48a3-4da7-9be8-712758cf28e5' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_history2',
    label: 'Do you have a history of any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'suicidal_thoughts', value: 'Suicidal thoughts' },
        { key: 'severe_depression', value: 'Severe depression' },
        {
          key: 'neither_of_these_apply_to_me',
          value: 'Neither of these apply to me'
        }
      ]
    },
    extras: { mdiQuestionId: '84bff99f-a8d6-4638-b95b-6a2eb6599af0' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_ever',
    label: 'Have you ever had any of the following:',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'elevated_psa_levels', value: 'Elevated PSA levels' },
        { key: 'prostate_issues', value: 'Prostate issues' },
        { key: 'prostate_cancer', value: 'Prostate cancer' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: '0b691175-3eb9-437e-9dc2-a610f2c19b69' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_rateStressLevelDailyBasis',
    label: 'How would you rate your stress level on a daily basis?',
    type: 'info',
    subLabel: '0: No stress 10: I am constantly experiencing stress',
    answer: {
      type: 'number',
      name: 'mdiMinoxidilFinasterideMenWomen_rateStressLevelDailyBasis'
    },
    extras: { mdiQuestionId: '2661cdb1-d27b-4efa-bb3b-147c483cfe33' }
  },
  {
    field:
      'mdiMinoxidilFinasterideMenWomen_experiencedRecentMajorStressIllness',
    label:
      'Have you experienced a recent major stress, illness, or weight loss?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'a18c412f-5dd6-4ee4-bd47-cb2a75efd12e' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRecent',
    label:
      'Can you provide your doctor with more insight to your recent major stress, illness, or weight loss:',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideMenWomen_provideDoctorMoreInsightRecent',
      rows: 4
    },
    extras: { mdiQuestionId: '5a813493-fd15-4adf-9950-0e0f1570192a' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_uploadClearWellLitPhoto',
    label: 'Please upload a clear, well-lit photo of the affected area:',
    type: 'file_upload',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId: 'mdiMinoxidilFinasterideMenWomen_uploadClearWellLitPhoto',
        buttonLabel: 'Upload'
      }
    ],
    extras: { mdiQuestionId: '7e98dc84-6e23-41f3-ad62-c2072ed08b07' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent   (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideMenWomen_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: 'd9b0dd72-1023-43c4-92fd-7b98f8aa65b6' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiMinoxidilFinasterideMenWomen_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: '7f9abeed-1776-403f-8acb-9d38b8ca9ab0' }
  },
  {
    field: 'mdiMinoxidilFinasterideMenWomen_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiMinoxidilFinasterideMenWomenAnswerField = Partial<
  QuestionAnswerMap<typeof mdiMinoxidilFinasterideMenWomenQuestions>
>;

export default mdiMinoxidilFinasterideMenWomenQuestions;
